'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudyImage = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _StudyImage = require('./StudyImage.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple wrapper to apply study image styles.
 */
var StudyImage = function StudyImage(_ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, rest),
    children
  );
};

exports.StudyImage = StudyImage;
StudyImage.propTypes = {
  /**
   * className required by glamorous
   * @ignore
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Child element either an img or container
   * with background-image
   */
  children: _propTypes2.default.element
};

exports.default = (0, _glamorous2.default)(StudyImage)(_StudyImage.defaultStyle, _StudyImage.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/StudyImage/StudyImage.js
// module id = 631
// module chunks = 0